import styled from "@emotion/styled"
import { FormFieldDto } from "api"
// import { NewText } from "ui"
import { Typography, TypographyProps } from "@mui/material"
import { colors, mediaQueries } from "ui"
import { FormFieldSettingsProps } from "../utils/interfaces"

const StyledNewText = styled(Typography)<TypographyProps>`
  ${mediaQueries.desktopM} {
    white-space: nowrap;
  }
`

type Props = {
  field: FormFieldDto
}
const FormTitleText = ({ field }: Props) => {
  const settings = field.settings as unknown as FormFieldSettingsProps
  return (
    <StyledNewText
      className="form-small-bottom-text"
      variant="body1"
      component={"p"}
      color={colors.black}
    >
      {settings.bodyText || settings.caption}
    </StyledNewText>
  )
}

export default FormTitleText
